// extracted by mini-css-extract-plugin
export default {"notCompletelyInvisible":"HyKyjCegtkZ0klw2xTiom","canDrop":"_3ogdDTG3BatU9afB2Dp0KV","isOver":"_22NfA8yg4jKu1E-9cuBpg1"};